import { createContext } from 'react'

export const Auth = createContext()
export const UserInfo = createContext()
